import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";
import moment from "moment";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  const isCompanyExpired = () => {
    if (!user || !user.company || user.company.id === 1) {
      return false;
    }

    const dueDate = user.company.dueDate;
    if (!dueDate) return false;

    const today = moment().startOf("day");
    const dueDateStart = moment(dueDate).startOf("day");
    return today.isAfter(dueDateStart, "day");
  };

  return (
    <RouterRoute
      {...rest}
      render={routeProps => {
        // Keep the current URL while an existing session is being renewed.
        if (loading) {
          return <BackdropLoading />;
        }

        if (!isAuth && isPrivate) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: routeProps.location } }}
            />
          );
        }

        if (isAuth && !isPrivate) {
          return (
            <Redirect
              to={{ pathname: "/", state: { from: routeProps.location } }}
            />
          );
        }

        if (
          isAuth &&
          isPrivate &&
          isCompanyExpired() &&
          rest.path !== "/financeiro-aberto"
        ) {
          return (
            <Redirect
              to={{
                pathname: "/financeiro-aberto",
                state: { from: routeProps.location }
              }}
            />
          );
        }

        return <Component {...routeProps} />;
      }}
    />
  );
};

export default Route;
